define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"dijit/_Container",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/_base/underscore",
	"csi/store/Values",
	"csi/xml",
	"dojo/text!./Tags.html",
	"csi/widget/CheckedMultiSelectDropdown"
], function(declare,Memory,_Container,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,_,Values,xml,template) {

	return declare([_WidgetBase, _Container, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,
		_comboNode: null,

		// Node[]: list of selected nodes
		//selection: null,

		// Store: store for all image tags
		//store: null,

		// String[]: current set of selected tags
		//_currentValue: null,

		// Boolean: necessary to focus combo node after tagging or untagging
		//_refocus: false,

		postMixInProperties: function() {
			this.selection = [];
			this.inherited(arguments);
		},

		_changeTags: function(/*String[]*/newValue, /*Boolean*/bRefocus) {
			// summary: event handler for when selected tags change
			if (_.isEqual(this._currentValue, newValue)) {
				return;
			}

			newValue = _.map(newValue, function(tagName){ return tagName.trim().toLowerCase(); });

			var added = _.difference(newValue, this._currentValue);
			var removed = _.difference(this._currentValue, newValue);


			if (added.length > 0 || removed.length > 0){
			    this._refocus = bRefocus;
			    this.onChange({add: added, remove: removed});
			    this._currentValue = _.clone(newValue);

			    // ensure that added tags are part of main store
			    var store = this.store;

			    _.each(added, function(tag) {
			        if (tag && !store.get(tag)) {
			            var	obj = {};
			            obj[store.idProperty] = tag;
			            obj[store.labelProperty] = tag;
			            store.put(obj);
			        }
			   });
			}
		},

		_onChangeTags: function(/*String[]*/newValue) {
			// summary: handle onChange event from comboNode
		        this._changeTags(newValue, true);
		},

		_setDisabledAttr: function(/*Boolean*/b) {
			// summary: set disabled status for tag/untag buttons
			if (!b && !this.store) {
				b = true;
			}

			_.each(this.getChildren(), function(child) {
				child.set("disabled", b);
			}, this);

			// if enabling immediately after searching, then return focus to value widget
			if (!b && this._refocus) {
				this._comboNode.focus();
				this._refocus = false;
			}
		},

		_setSelectionAttr: function(/*Node[]*/nodes) {
		        // summary: set store and value based on selected nodes
                       if (this.selection) {
                                var urlsOld = _.map(this.selection, xml.nodeGetURL).sort();
                                var urlsNew = _.map(nodes, xml.nodeGetURL).sort();
                                if (_.isEqual(urlsOld, urlsNew)) {
                                    return;
                                }

                                // if selection is changing, make sure value has not changed; if so, trigger onChange event
                                this._changeTags(this._comboNode.get("value"), false);
                        }

                        this._set("selection", nodes);

                        if (this.store) {
                                this._updateTags();
                        }
		},

        _setStoreAttr: function(/*Store*/store) {
            // summary: set store for this widget, and store for combo
            var self = this;

            store.query().then(function() {
				self._set("store", store);
            	self._updateTags();
            });
		},

		_updateTags: function() {
			// summary: set multi-select store and value based on selected nodes
			var store = this.store;
			var nodes = this.selection;
			var value = [];
			var n = nodes.length;
			if (n) {
			    // if there are selected nodes, then initialize widget with store of common values (whether all tagged with a value, or none)
		        var mapTags = {};

		        _.each(nodes, function(node) {
			        _.each(node.Tags, function(key, tag) {
			            mapTags[tag] = (mapTags[tag] || 0) + 1;
			        });
		        });

		        console.assert(store.isLoaded());

		        var values = store.query().filter(function(item) {
		            var tag = store.getIdentity(item);
		            if (mapTags[tag] == n) {
		                value.push(tag);
		                return true;
		            }

		            return !mapTags[tag];
		        });

		        store = Values.createFromValues(values);

		        this._currentValue = value;
		        this._comboNode._onChangeActive = false;
		        this._comboNode.set("store", store);
		        this._comboNode.resetSelected(value);
		        this._comboNode._onChangeActive = true;
			}
		}
	});
});